<script setup lang="ts">
import { useModalStore } from "~/stores/modal";

const {
	ordersConfirmClose,
	ordersConfirmReject,
	ordersConfirmRefund,
	shippingsModalEdit,
	teamModalEdit,
	teamModalInvite,
	kindsConfirmDelete,
	kindsModalEdit,
	colorsModalEdit,
	colorsConfirmDelete,
	sizesModalEdit,
	sizesConfirmDelete,
	materialsConfirmDelete,
	tagsModalEdit,
	tagsConfirmDelete,
	collectionsModalEdit,
	collectionsConfirmDelete,
	customersModalEdit,
	pricePoliciesConfirmDelete,
	itemPrototypesConfirmDelete,
	itemsConfirmDelete,
	itemsConfirmDeleteMultiple,
	profileModalEdit
} = useModalStore();
</script>

<template>
	<div>
		<!-- Orders -->
		<OrdersConfirmClose v-if="ordersConfirmClose.isModalOpened" />
		<OrdersConfirmReject v-if="ordersConfirmReject.isModalOpened" />
		<OrdersConfirmRefund v-if="ordersConfirmRefund.isModalOpened" />

		<!-- Shippings -->
		<ShippingsModalEdit v-if="shippingsModalEdit.isModalOpened" />

		<!-- Products -->
		<ItemPrototypesConfirmDelete v-if="itemPrototypesConfirmDelete.isModalOpened" />
		<ItemsConfirmDelete v-if="itemsConfirmDelete.isModalOpened" />
		<ItemsConfirmDeleteMultiple v-if="itemsConfirmDeleteMultiple.isModalOpened" />
		<TagsModalEdit v-else-if="tagsModalEdit.isModalOpened" />
		<TagsConfirmDelete v-else-if="tagsConfirmDelete.isModalOpened" />
		<CollectionsModalEdit v-else-if="collectionsModalEdit.isModalOpened" />
		<CollectionsConfirmDelete v-else-if="collectionsConfirmDelete.isModalOpened" />

		<!-- Components -->
		<KindsModalEdit v-else-if="kindsModalEdit.isModalOpened" />
		<KindsConfirmDelete v-else-if="kindsConfirmDelete.isModalOpened" />
		<ColorsModalEdit v-else-if="colorsModalEdit.isModalOpened" />
		<ColorsConfirmDelete v-else-if="colorsConfirmDelete.isModalOpened" />
		<SizesModalEdit v-else-if="sizesModalEdit.isModalOpened" />
		<SizesConfirmDelete v-else-if="sizesConfirmDelete.isModalOpened" />
		<MaterialsConfirmDelete v-else-if="materialsConfirmDelete.isModalOpened" />

		<!-- Customers -->
		<CustomersModalEdit v-else-if="customersModalEdit.isModalOpened" />

		<!-- Price Policies -->
		<PricePoliciesConfirmDelete v-else-if="pricePoliciesConfirmDelete.isModalOpened" />

		<!-- Settings -->
		<TeamModalEdit v-else-if="teamModalEdit.isModalOpened" />
		<TeamModalInvite v-else-if="teamModalInvite.isModalOpened" />
		<ProfileModalEdit v-else-if="profileModalEdit.isModalOpened" />
	</div>
</template>
